import { combineReducers } from 'redux';
import common from './common/reducer';
import flightCourse from './flightCourse/reducer';

const rootReducer = combineReducers({
    state: (state = {}) => state,
    common,
    flightCourse,
});

export default rootReducer;